import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from './PageTitle';

const DynamicPageTitle: React.FC = () => {
  const location = useLocation();

  const title = useMemo(() => {
    if (
      location.pathname.startsWith('/onboarding/') ||
      location.pathname === '/rezen-signup'
    ) {
      return 'One Real: Registration - TCs & Team Admins';
    } else if (location.pathname === '/login') {
      return 'One Real: Sign In';
    }
    return 'One Real Mortgage';
  }, [location.pathname]);

  return <PageTitle title={title} />;
};

export default DynamicPageTitle;
